<div class="page-container">
  <fc-map-control
    class="map-overlay"
    [approvalRequired]="approvalRequired"
    [currentUser]="currentUser"
    [activeSite]="site"
    [readOnlyMap]="readOnlyMap"
    [drawer]="drawer"
    [currentStands]="currentStands"
    [showParcelTip]="showZoomInNote"
    (revertChanges)="revertChanges()"
    (generateMap)="generateMap.emit()"></fc-map-control>
  <div #mapCanvas class="map match-parent" id="forest-map" [ngClass]="currentMapStyle">
    <fc-map-layers-selector (mapStyleLoading)="setMapLoading()" [mapService]="mapService" [standMap]="true"
                            [isAdmin]="currentUser?.isAdmin"></fc-map-layers-selector>
    <div *ngIf="showZoomInNote" class="zoom-in">
      <div class="header">Zoom In To See Forest Layer</div>
      <div class="message">Use the plus icon to the left to get closer</div>
    </div>
    @if (currentUser.isAdmin || currentUser.isLimitedAdmin) {
      <div
        class="site-detail-popup map-popup {{ hoverRedflagFeature.length > 0 || hoverForestFeature.length > 0 || (currentMapControls.redflagSelect && redflagDetails.length > 0) ? '' : 'hidden' }}">
        @if (currentMapControls.redflagSelect && redflagDetails.length > 0 && site.approvedDate == null && site.canceledDate == null) {
          <div class="popup-title">Redflag Overlap</div>
          <div class="popup-border"></div>
          @for (layer of redflagDetails; track layer) {
            <div class="popup-details">
              <fa-icon [icon]="['far', 'square-dashed-circle-plus']" class="select-all-icon"
                       matTooltip="Click to select this entire layer from the site for removal"
                       matTooltipClass="fc-tooltip"
                       matTooltipPosition="right"
                       (click)="selectRedflagLayer(layer.layer)"></fa-icon>
              {{
                (this.redflagMap[layer.layer]
                  ? this.redflagMap[layer.layer]
                  : layer.layer)
              }}: {{ layer.area | number: '1.0-2' }} acres
            </div>
          }
        }
        @if (hoverRedflagFeature.length > 0 || hoverForestFeature.length > 0) {
          <div class="popup-title">Map Layers</div>
          <div class="popup-border"></div>
          @for (feature of hoverRedflagFeature; track feature) {
            <div
              class="popup-details">{{ redflagMap[feature.properties.layer] ? redflagMap[feature.properties.layer] : feature.properties.layer }}
              ({{ feature.id }})
            </div>
          }
          @for (feature of hoverForestFeature; track feature) {
            <div
              class="popup-details">{{ feature.properties.strata_txt }} ({{ feature.id }})
            </div>
          }
        }
      </div>
    }
    <div class="legend">
      <div class="included-parcels">Included Parcel</div>
      <div class="included-stands">Included Stand</div>
      <div class="possible-forests">Eligible Forests</div>
      <div class="map-location">
        Map Center:
        <br />
        {{ currentLat }}, {{ currentLong }}
      </div>
    </div>
    <div class="disclaimer">
      Satellite images may differ from current up-to-date forest layer. <br />The forest layer shown may have areas
      removed, including high-slope, protected, and other ineligible areas.
    </div>
  </div>
</div>
